import { render, staticRenderFns } from "./CampesenaTablero.vue?vue&type=template&id=10fb53a7&scoped=true"
import script from "./CampesenaTablero.vue?vue&type=script&lang=js"
export * from "./CampesenaTablero.vue?vue&type=script&lang=js"
import style0 from "./CampesenaTablero.vue?vue&type=style&index=0&id=10fb53a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fb53a7",
  null
  
)

export default component.exports